import {lazy} from 'react';

export const ChatViewAsync = lazy(() =>
    import('./ChatView')
);
